import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public updateDevice(context, lang, oauthToken, udid, application, appVersion, battery, brand, brightness,
                      connectionDevice, description, deviceName, deviceType, ipAddress, locked, mac, major,
                      minor, model, note, notifyBackOffice, osVersion, paperOut, platform, pushToken, serialNumber,
                      signal, volume, wifiSsid
  ) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    if (context) {
      options['headers'] = options['headers'].append('context', context);
    }
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { application, appVersion, battery, brand, brightness, connectionDevice, description,
      deviceName, deviceType, ipAddress, locked, mac, major, minor, model, note, notifyBackOffice, osVersion,
      paperOut, platform, pushToken, serialNumber, signal, volume, wifiSsid };
    return this.http.post(this.BASE_URL + '/api/v2.0/device/ws_updateDevice', item, options);
  }

}
